import _classCallCheck from "/opt/build/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/opt/build/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { createElement, forwardRef, Component, Children, Fragment } from 'react';
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

function __rest(s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}

var removeKeys = function removeKeys(blackList) {
  return function (obj) {
    var cleanObj = obj;
    blackList.forEach(function (item) {
      return Object.prototype.hasOwnProperty.call(cleanObj, item) && delete cleanObj[item];
    });
    return cleanObj;
  };
};

var key = function key() {
  return Math.random().toString(36).substring(2);
};

var blackListProps = ['rowGap', 'columnWidth', 'uniqueid'];
var removeBlackListed = removeKeys(blackListProps);

var Snuggle = /*#__PURE__*/function (_Component) {
  _inherits(Snuggle, _Component);

  var _super = _createSuper(Snuggle);

  function Snuggle(props) {
    var _this;

    _classCallCheck(this, Snuggle);

    _this = _super.call(this, props);
    _this.gridId = null;
    _this.reposition = false;
    _this.elements = [];
    _this.grid = null;

    _this.getRef = function (ref) {
      if (ref && ref.firstElementChild) {
        _this.elements.push(ref);
      }
    };

    _this.setValues = function () {
      var _this$props$rowGap = _this.props.rowGap,
          rowGap = _this$props$rowGap === void 0 ? 0 : _this$props$rowGap;

      if (_this.elements.length === 0) {
        return;
      }

      _this.elements.forEach(function (item) {
        var itemRef = item;

        if (itemRef && itemRef.firstElementChild) {
          var firstElement = itemRef.firstElementChild;
          var itemHeight = firstElement.getBoundingClientRect().height;
          var rowSpan = Math.ceil((itemHeight + rowGap) / rowGap);
          itemRef.style.gridRowEnd = "span ".concat(rowSpan);
        }
      });

      if (!_this.reposition) {
        window.requestAnimationFrame(_this.setValues);
        _this.reposition = true;
      }
    };

    _this.onLoadImages = function () {
      if (_this.grid) {
        var images = _this.grid.getElementsByTagName('img');

        Array.from(images).forEach(function (img) {
          var imageRef = img;

          imageRef.onload = function () {
            _this.setValues();
          };
        });
      }
    };

    _this.createGridStyle = function () {
      var _this$props = _this.props,
          _this$props$rowGap2 = _this$props.rowGap,
          rowGap = _this$props$rowGap2 === void 0 ? 0 : _this$props$rowGap2,
          _this$props$columnWid = _this$props.columnWidth,
          columnWidth = _this$props$columnWid === void 0 ? 0 : _this$props$columnWid;
      return "\n      <style>\n        .".concat(_this.gridId, " {\n          display: grid;\n          grid-gap: ").concat(rowGap, "px;\n          grid-template-columns: repeat(auto-fill, minmax(").concat(columnWidth, "px, 1fr));\n        }\n      </style>");
    };

    _this.gridId = "snuggle--".concat(props.uniqueid || key());
    return _this;
  }

  _createClass(Snuggle, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setValues();
      this.onLoadImages();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.setValues();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _a = this.props,
          children = _a.children,
          _a$item = _a.item,
          item = _a$item === void 0 ? createElement('div') : _a$item,
          _a$container = _a.container,
          container = _a$container === void 0 ? createElement('div') : _a$container,
          innerRef = _a.innerRef,
          compProps = __rest(_a, ["children", "item", "container", "innerRef"]);

      var hasChildren = Children.count(children) > 0;

      if (!hasChildren) {
        return null;
      }

      var refItem = function refItem(n) {
        _this2.getRef(n);
      };

      var refGrid = function refGrid(node) {
        _this2.grid = node;

        if (innerRef && innerRef.current) {
          innerRef.current = node;
          innerRef.current.resize = _this2.setValues;
        }
      };

      var renderChildren = Children.map(children, function (child) {
        var itemProps = removeBlackListed(Object.assign(Object.assign({}, item.props), {
          key: key(),
          ref: refItem
        }));

        if (item) {
          return createElement(item.type, itemProps, child);
        }

        return null;
      });
      var containerProps = removeBlackListed(Object.assign(Object.assign(Object.assign({}, container.props), compProps), {
        className: "".concat(this.gridId, " ").concat(container.props.className || ''),
        ref: refGrid
      }));
      return createElement(Fragment, null, createElement('div', {
        dangerouslySetInnerHTML: {
          __html: this.createGridStyle()
        }
      }), createElement(container.type, containerProps, renderChildren));
    }
  }]);

  return Snuggle;
}(Component);

Snuggle.defaultProps = {
  columnWidth: 250,
  container: createElement('div'),
  item: createElement('div'),
  rowGap: 20,
  uniqueid: ''
};
var ExportableSnuggle = forwardRef(function (props, ref) {
  return createElement(Snuggle, Object.assign({
    innerRef: ref
  }, props));
});
export default ExportableSnuggle;